import React, { Component } from "react";
import PropTypes from "prop-types";
import MapContainer from "../maps/MapContainer";

class Dashboard extends Component {
  render() {
    const { devices } = this.props.devices;

    return (
      <div className="map">
        <MapContainer devices={devices} />
      </div>
    );
  }
}

/*Dashboard.propTypes = {
  getCurrentUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  getDevices: PropTypes.func.isRequired,
  devices: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  user: state.user,
  auth: state.auth,
  devices: state.devices
});*/

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js